var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.$t("personalInformations")))]),_vm._v(" "),(_vm.clientType != 1)?_c("company-informations",{tag:"div"}):_vm._e(),_vm._v(" "),(_vm.clientType === 1)?_c("personal-informations",{tag:"div"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }